import * as jwtDecode from 'jwt-decode'

const getToken = () => {
  const commandeerToken = window.localStorage.getItem('commandeer_token')
  const token = window.localStorage.getItem('bearer_token')
  const tokenToUse = commandeerToken || token

  try {
    const decodedJwt = jwtDecode(tokenToUse)
    return decodedJwt.token
  } catch (e) {
    return null
  }
}

export default getToken
